import { Component, Input, ViewChild, ElementRef, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { BrandingService } from '../../../../../UI/src/app/shared/branding/branding.service';

@Component({
  selector: 'sts-donut',
  templateUrl: './donut.component.html'
})
export class DonutComponent implements OnInit {
  @ViewChild('doughnutCanvas') doughnutCanvas: ElementRef;
  @Input() percentage: number;
  @Input() donutId: number;
  displayData: string;
  doughnutChart: any;
  colorData = [
      { max: 0, color: '#eeeeee' },
      { max: 25, color: '#f27c2a' },
      { max: 50, color: '#ffc600' },
      { max: 75, color: '#227AB9' },
      { max: 100, color: '#1fbba6' },
    ];

  constructor(private brandingService: BrandingService) { }

  ngOnInit() {
    this.colorData = this.brandingService.getDonutThemeColors();
    this.percentage = this.percentage || 0;
    this.percentage = Math.ceil(this.percentage);
    this.displayData = this.percentage + '%';
    this.getDoughnutChart();
  }

  private getColor(percent: number) {
    var ty = (this.colorData.filter(a => a.max >= percent))[0];
    var percentTextId = 'donut_' + this.donutId;
    setTimeout(function() {
      const percentTexts = document.getElementsByClassName(percentTextId) as HTMLCollectionOf<Element>;
      for (let ele of <any>percentTexts) {
        ele.style.setProperty("color", ty.color, "important");
      }
    }, 100);
    return ty.color;
  }

  private getDoughnutChart() {
    const clr = this.getColor(this.percentage);
    this.doughnutChart = new Chart(this.doughnutCanvas.nativeElement, {
      type: 'doughnut',
      data: {
        datasets: [{
          data: [this.percentage, 100 - this.percentage],
          backgroundColor: [
            clr,
            "#EEEEEE"
          ],
          hoverBackgroundColor: [
            clr,
            "#EEEEEE"
          ]
        }]
      },
      options: {
        animation: {
          duration: 1
        },
        tooltips: {
          enabled: false
        },
        elements: {
          arc: {
            borderWidth: 0
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/lib/donut/donut.component.ts